import { Route, Routes } from "react-router-dom";
import Billing from "../pages/Billing";
import CaseDetail from "../pages/CaseDetail";
import Cases from "../pages/Cases";
import GetReferralLink from "../pages/GetReferralLink";
import Home from "../pages/Home";
import Patients from "../pages/Patients";
import Plans from "../pages/Plans";
import QuickRecord from "../pages/QuickRecord";
import Settings from "../pages/Settings";
import StripeCheckout from "../pages/StripeCheckout";
import Success from "../pages/Success";
import TemplateDetail from "../pages/TemplateDetail";
import Templates from "../pages/Templates";
import TrackReferral from "../pages/TrackReferral";
import NotFound from "./NotFound";
import ChangeLocation from "./Settings/ChangeLocation";
import Integrations from "@/pages/Integrations";

const RouteSwitcher = () => {
  return (
    <Routes>
      {/* <Route index element={<Painting />} /> */}
      <Route path="" index element={<Home />} />
      <Route path="*" element={<NotFound />} />
      <Route path="patients" element={<Patients />} />
      <Route path="cases/:patientId" element={<Cases />} />
      <Route path="case-detail/:caseId" element={<CaseDetail />} />
      <Route path="template-detail/:templateId" element={<TemplateDetail />} />
      <Route path="templates" element={<Templates />} />
      <Route path="settings/account" element={<Settings />} />
      <Route path="change-location" element={<ChangeLocation />} />
      <Route path="plans" element={<Plans />} />
      <Route path="track-referral" element={<TrackReferral />} />
      <Route path="referral-link" element={<GetReferralLink />} />
      <Route path="billing" element={<Billing />} />
      <Route path="success" element={<Success />} />
      <Route path="settings" element={<Settings />} />
      <Route path="checkout" element={<StripeCheckout />} />
      <Route path="quick-record" element={<QuickRecord />} />
      <Route path="integrations" element={<Integrations />} />
    </Routes>
  );
};

export default RouteSwitcher;
